import { EditorStyles } from '@modules/editor/EditorContainer';
import { styled } from '@mui/material';

export const ChatResponseStyled = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
  width: '100%',
  overflow: 'hidden',
}));

export const StyledMarkupEditor = styled(EditorStyles)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  gap: 1,
  overflow: 'hidden',
  '& > *': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: 8,
    overflow: 'hidden',
    div: {
      overflow: 'hidden',
    },
  },
  p: {
    margin: 0,
    padding: 0,
  },
  ...theme.typography.body2,
  '&.reasoning': {
    color: theme.palette.text.secondary,
  },
}));

export const HeaderStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  cursor: 'pointer',
  color: theme.palette.text.secondary,
}));
